import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';

export default function Forbidden() {
  return (
    <div className="bg-slate-50 min-h-[75vh] flex items-center justify-center py-20 px-4">
      <SeoMeta
        title="403 - Adgang nægtet | ENTREPRENØR LANG ApS"
        description="Du har ikke tilladelse til at tilgå denne side."
      />

      <div className="max-w-xl mx-auto text-center bg-white p-8 sm:p-12 rounded-3xl border border-slate-200 shadow-xl space-y-6">
        <div className="w-20 h-20 rounded-2xl bg-amber-100 text-amber-800 flex items-center justify-center mx-auto text-3xl font-extrabold">
          <i className="fa-solid fa-lock text-amber-700" aria-hidden="true" />
        </div>

        <div>
          <span className="text-xs font-bold uppercase tracking-wider text-amber-800 bg-amber-50 px-3 py-1 rounded-full">
            Fejlkode 403
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-3 tracking-tight">
            Adgang nægtet
          </h1>
          <p className="text-slate-600 text-sm sm:text-base mt-2 leading-relaxed">
            Du har ikke de nødvendige tilladelser til at se det efterspurgte indhold.
          </p>
        </div>

        <div className="pt-2 border-t border-slate-100">
          <p className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-4">
            Find vej videre:
          </p>
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            <Link
              to="/"
              className="p-3 rounded-xl bg-slate-50 hover:bg-emerald-50 text-slate-800 hover:text-emerald-800 text-xs font-bold border border-slate-200 transition-colors"
            >
              <i className="fa-solid fa-house block text-base mb-1.5 text-emerald-600" aria-hidden="true" />
              Forsiden
            </Link>
            <Link
              to="/ydelser"
              className="p-3 rounded-xl bg-slate-50 hover:bg-emerald-50 text-slate-800 hover:text-emerald-800 text-xs font-bold border border-slate-200 transition-colors"
            >
              <i className="fa-solid fa-screwdriver-wrench block text-base mb-1.5 text-emerald-600" aria-hidden="true" />
              Ydelser
            </Link>
            <Link
              to="/galleri"
              className="p-3 rounded-xl bg-slate-50 hover:bg-emerald-50 text-slate-800 hover:text-emerald-800 text-xs font-bold border border-slate-200 transition-colors"
            >
              <i className="fa-solid fa-images block text-base mb-1.5 text-emerald-600" aria-hidden="true" />
              Galleri
            </Link>
            <Link
              to="/kontakt-os"
              className="p-3 rounded-xl bg-slate-50 hover:bg-emerald-50 text-slate-800 hover:text-emerald-800 text-xs font-bold border border-slate-200 transition-colors"
            >
              <i className="fa-solid fa-envelope block text-base mb-1.5 text-emerald-600" aria-hidden="true" />
              Kontakt
            </Link>
          </div>
        </div>

        <div className="pt-2">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-emerald-700 hover:bg-emerald-800 text-white font-bold text-sm shadow transition-all"
          >
            <i className="fa-solid fa-arrow-left text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
